import { useMemo, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function TechnologyInner({ demandId = "DEM-001" }) {
  // TRM Knowledge Portal - Essential Project viewer
  // Using proxied URL to avoid CSP issues
  const trmUrl = "/trm/report?XML=reportXML.xml&XSL=home.xsl&cl=en-gb&LABEL=Home";
  const [iframeError, setIframeError] = useState(false);

  const openTRMInNewTab = () => {
    window.open("https://aiea.archsystemsinc.com/trm/report?XML=reportXML.xml&XSL=home.xsl&cl=en-gb&LABEL=Home", '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'var(--cares-surface-board)'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: 'var(--cares-surface-card)',
        borderBottom: '1px solid var(--cares-line)',
        padding: '20px 30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '5px'
            }}>
              Technical Reference Model
            </h1>
            <p style={{
              fontSize: '14px',
              color: 'var(--cares-text-3)'
            }}>
              Knowledge Portal - Essential Project Viewer
            </p>
          </div>
          <button
            onClick={openTRMInNewTab}
            style={{
              backgroundColor: 'var(--cares-blue)',
              color: 'var(--cares-text-max)',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '500',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = 'var(--cares-blue)'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'var(--cares-blue)'}
          >
            <span>🔗</span>
            <span>Open in New Tab</span>
          </button>
        </div>
      </div>

      {/* TRM iframe */}
      {!iframeError ? (
        <iframe
          src={trmUrl}
          title="Technical Reference Model"
          style={{
            width: '100%',
            height: 'calc(100vh - 100px)',
            border: 'none',
            backgroundColor: 'var(--cares-surface-card)'
          }}
          onError={() => setIframeError(true)}
        />
      ) : (
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px'
        }}>
          <div style={{
            maxWidth: '600px',
            backgroundColor: 'var(--cares-surface-card)',
            borderRadius: '8px',
            padding: '40px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}>
            <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px' }}>
              Unable to Load TRM
            </h2>
            <p style={{ fontSize: '14px', color: 'var(--cares-text-3)', marginBottom: '20px' }}>
              The Technical Reference Model could not be loaded in the embedded view.
            </p>
            <button
              onClick={openTRMInNewTab}
              style={{
                backgroundColor: 'var(--cares-blue)',
                color: 'var(--cares-text-max)',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '500',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Open TRM in New Tab
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Technology({ demandId = "DEM-001" }) {
  const client = useMemo(() => new QueryClient(), []);
  return (
    <QueryClientProvider client={client}>
      <TechnologyInner demandId={demandId} />
    </QueryClientProvider>
  );
}